<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Ruteador Manual
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Facturación masiva</span>
      <span> /</span>
      <span>Ruteador Manual</span>
    </p>
  </div>
</div>
<form [formGroup]="formRuteadorManual" autocomplete="off">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">

        <ng-container *ngIf="permiteUnidadNegocio">
          <div class="col" style="max-width: 300px;">
            <div class="md-form">
              <mdb-select label="Unidad de Negocio" [options]="optionsUnidadesDeNegocio" placeholder="Unidad de negocio"
                [filterEnabled]="true" formControlName="unidad_negocio_codigo">
              </mdb-select>
              <div *ngIf="
               formRuteadorManual.get('unidad_negocio_codigo').invalid &&
                (formRuteadorManual.get('unidad_negocio_codigo').dirty ||
                formRuteadorManual.get('unidad_negocio_codigo').touched)
                ">
                <mdb-error *ngIf="formRuteadorManual.get('unidad_negocio_codigo').hasError('required')">
                  Ingrese unidad de negocio
                </mdb-error>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="col" style="max-width: 200px;">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" placeholder="Fecha" formControlName="fechafiltroDesde"
              id="fechafiltroDesde" #fechafiltro required
              (dateChanged)="filtroPorFecha($event, true)"></mdb-date-picker>

            <label>Desde</label>
          </div>
        </div>
        <div class="col" style="max-width: 200px;">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" placeholder="Fecha" formControlName="fechafiltroHasta"
              id="fechafiltroHasta" #fechafiltro required (dateChanged)="filtroPorFecha($event, false)">
            </mdb-date-picker>
            <label>Hasta</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form mb-0">
            <mdb-select [options]="optionsEstado" [multiple]="false" formControlName="estadofiltro"
              [filterEnabled]="true" [highlightFirst]="false" id="estadofiltro" #estadofiltro
              placeholder="Seleccione estado">
            </mdb-select>
            <label>Estado</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form mb-0">
            <mdb-select [options]="optionsComuna" [multiple]="true" formControlName="comunafiltro"
              [filterEnabled]="true" [highlightFirst]="false" placeholder="Seleccionar Comuna" id="comunafiltro"
              #comunafiltro>
            </mdb-select>
            <label>Comuna</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form mb-0">
            <mdb-select [options]="optionsVendedor" [multiple]="true" formControlName="vendedorfiltro"
              [filterEnabled]="true" [highlightFirst]="false" placeholder="Seleccionar Vendedor" id="vendedorfiltro"
              #vendedorfiltro>
            </mdb-select>
            <label>Vendedor</label>
          </div>
        </div>
        <div class="col">
          <div class="md-form mb-0">
            <mdb-select [options]="optionsTerritorios" style="min-width: 300px;" [multiple]="true"
              [filterEnabled]="true" [highlightFirst]="false" formControlName="territoriofiltro"
              placeholder="Seleccionar Terrirorio" id="territoriofiltro" #territoriofiltro>
            </mdb-select>
            <label>Territorio</label>
          </div>
        </div>

      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div class="resultados pl-2">
        <div class="resultados pl-2" *ngIf="showTable === true">
          <strong>Total Documentos</strong>
          <span class="dummyTxt" *ngIf="listdocumentRec?.length === 0">0</span>
          <span class="dummyTxt" *ngIf="listdocumentRec?.length > 0 null">{{total_documentos}}</span>
          <strong>Documentos asignados</strong>
          <span class="dummyTxt" *ngIf="listdocumentRec?.length === 0">0</span>
          <span class="dummyTxt" *ngIf="listdocumentRec?.length > 0 ">{{documentos_entregados}}</span>
          <strong>Documentos pendientes</strong>
          <span class="dummyTxt" *ngIf="listdocumentRec?.length === 0">0</span>
          <span class="dummyTxt" *ngIf="listdocumentRec?.length > 0">{{documentos_pendientes}}</span>
          <strong>Clientes</strong>
          <span class="dummyTxt" *ngIf="listdocumentRec?.length === 0">0</span>
          <span class="dummyTxt" *ngIf="listdocumentRec?.length > 0">{{numeros_clientes}}</span>
        </div>
      </div>
      <div>
        <button mdbBtn type="submit" color="secondary" size="sm" mdbWavesEffect (click)="buscarPorFiltros()">
          <mdb-icon fas icon="search"></mdb-icon>
          Buscar
        </button>
        <button mdbBtn type="submit" color="secondary" size="sm" mdbWavesEffect (click)="LimpiarData()">
          Limpiar
        </button>
      </div>
    </div>
  </div>

</form>



<div class="card mb-2 wow detalle-cliente" *ngIf="showTable === true">
  <div class="card-body">
    <!-- MAPA -->
    <div class="row filtros-body">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">
                  <mdb-checkbox [(ngModel)]="CheckBoxAllValue" (change)="checkAllChange($event)"
                    [checked]="true">
                  </mdb-checkbox>
                </th>
                <th scope="col">Fecha</th>
                <th scope="col">Doc</th>
                <!-- <th scope="col">Numero</th> -->
                <!-- <th scope="col">Ruta</th> -->
                <!-- <th scope="col">Rec.</th> -->
                <th scope="col">Can.</th>
                <th scope="col">Peso</th>
                <th scope="col">Volumen</th>
                <th scope="col">Monto</th>
                <th scope="col">Comuna</th>
                <th scope="col">Vendedor</th>
                <th scope="col">Estado</th>
                <th scope="col">Cliente</th>
                <th scope="col">Dirección</th>
              </tr>
            </thead>
            <tbody *ngIf="loadingDetalles">
              <tr>
                <td colspan="100%" style="text-align: center">
                  <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </td>
              </tr>
            </tbody>
            <tbody *ngIf="!loadingDetalles">

              <tr *ngIf="!loadingDetalles && listdocumentRec?.length === 0">
                <td colspan="100%" style="text-align: center">
                  No se encontró información
                </td>
              </tr>
              <tr *ngFor="let doc of listdocumentRec; let i = index" [class.active]="i == HighlightRow"
                [ngClass]="{AsigData:doc.estado == 1}">
                <td>
                  <mdb-checkbox [checked]="doc.additionalInfo.checked"
                    (change)='checkDetalle(doc.additionalInfo, $event); marcar(i, doc);'></mdb-checkbox>
                </td>
                <td>{{doc.fecha_emision | fecha}}</td>
                <td>{{doc.folio}}</td>
                <td>{{doc.total_cantidad}}</td>
                <td>{{doc.total_peso}}</td>
                <td>{{doc.total_volumen | numerico}}</td>
                <td>$ {{doc.total_monto | numerico}}</td>
                <td>{{doc.comuna}}</td>
                <td>{{doc.vendedor}}</td>
                <td>{{doc.estado_cliente}}</td>
                <td>{{doc.nombre_cliente}}</td>
                <td>{{doc.direccion_completa}}</td>
              </tr>
              <!-- <tr>
                  <td colspan="100%" style="text-align: center">No se encontraron resultados.</td>
                </tr> -->
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row filtros-body justify-content-end mt-2" *ngIf="listdocumentRec.length > 0">
      <div class="col-12 col-md-6">
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col"></th>
              <th scope="col" class="text-right">Cajas</th>
              <th scope="col" class="text-right">Unidad</th>
              <th scope="col" class="text-right">Peso</th>
              <th scope="col" class="text-right">Volumen</th>
              <th scope="col" class="text-right">Monto</th>
              <th scope="col" class="text-right">Documentos</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td scope="col"><strong>Totales</strong></td>
              <th class="text-right">{{sumTotalCajas | numerico}}</th>
              <th class="text-right">{{sumTotalUnidad | numerico}}</th>
              <th class="text-right">{{sumTotalPeso}}</th>
              <th class="text-right">{{sumTotalVolumen}}</th>
              <th class="text-right">{{sumTotalMonto | numerico}}</th>
              <th class="text-right">{{sumTotalDocumentos | numerico}}</th>
            </tr>
            <tr>
              <td scope="col"><strong>Seleccionados</strong></td>
              <th class="text-right">{{sumCajasSelect | numerico}}</th>
              <th class="text-right">{{sumUnidadSelect | numerico}}</th>
              <th class="text-right">{{sumPesoSelect}}</th>
              <th class="text-right">{{sumVolumenSelect}}</th>
              <th class="text-right">{{sumMontoSelect | numerico}}</th>
              <th class="text-right">{{listdocumentRecSelect.length | numerico}}</th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row filtros-body">
      <div class="col" style="max-width:100%;">

        <div class="">
          <!--        <button class="float-right" color="info" mdbBtn type="button" size="sm" mdbWavesEffect data-toggle="modal"-->
          <!--                data-target="#dvModalAsignarCamionRutas" (click)="showModalverAddEditRutasModal()"-->
          <!--                mdbTooltip="Crear Ruta"-->
          <!--                placement="right">-->
          <!--          Crear Ruta-->
          <!--        </button>-->

          <button class="float-right" color="info" mdbBtn type="button" size="sm" mdbWavesEffect data-toggle="modal"
            data-target="#dvModalAsignarCamionRutas" (click)="showModalAsignarCamionRutas()" mdbTooltip="Asignar Camión"
            placement="right">
            Asignar
          </button>

          <button class="btn btn-sm float-right" color="info" mdbBtn type="button" size="sm" mdbWavesEffect
            data-toggle="modal" data-target="#dvModalAsignarCamionRutas" (click)="showModalverAddEditRutasModal()"
            placement="right">
            Crear Ruta
          </button>
          <button class="btn btn-sm float-right" color="info" mdbBtn type="button" size="sm" mdbWavesEffect
            data-toggle="modal" data-target="#dvModalAsignarCamionRutas" (click)="showModalAsignarCamionRutas(true)"
            mdbTooltip="Editar Rutas" placement="right">
            Editar Rutas
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <form [formGroup]="formRuteadorManual">
      <div class="card-body justify-content-between">

        <div class="row filtros-body">
          <div class="col">
            <div class="row">
              <div class="col" style="max-width: 150px;">
                <div class="md-form">
                  <mdb-date-picker [inline]="true" placeholder="Fecha" id="fechafiltroDetalleRecorridoDesde"
                    formControlName="fechafiltroDetalleRecorridoDesde" #fechafiltro required>

                  </mdb-date-picker>
                </div>
              </div>
              <div class="col" style="max-width: 150px;">
                <div class="md-form">
                  <mdb-date-picker [inline]="true" placeholder="Fecha" id="fechafiltroDetalleRecorridoHasta"
                    formControlName="fechafiltroDetalleRecorridoHasta" #fechafiltro required>

                  </mdb-date-picker>
                </div>
              </div>
              <div class="col" style="max-width: 200px;">
                <div class="md-form">
                  <mdb-select [options]="optionsEstadoDetalle" [multiple]="false" [filterEnabled]="true"
                    [highlightFirst]="false" id="estadofiltroDetalleRecorrido"
                    formControlName="estadofiltroDetalleRecorrido" #estadofiltro placeholder="Estado">
                  </mdb-select>
                  <label>Estado</label>
                </div>
              </div>

            </div>
          </div>
          <div class="col text-right">
            <button mdbBtn type="submit" color="secondary" size="sm" mdbWavesEffect (click)="buscarPorFiltroDetalle()">
              <mdb-icon fas icon="search"></mdb-icon>
              Buscar
            </button>
          </div>
        </div>

      </div>
    </form>


    <!-- CAMIONES POR CHOFER -->

    <!-- BOTON GENERAR PDF -->
    <div class="d-flex">
      <ng-container *ngIf="!loadingPdf">
        <button mdbBtn type="button" color="primary" mdbWavesEffect
          (click)="ObtenerDataToPdf()" mdbTooltip="Generar PDFs"
          [disabled]="!permiteObtenerPDF()">
          <mdb-icon fas icon="file-pdf"></mdb-icon>
          Generar PDFs ({{listadoCamionChoferSelectCount}})
        </button>
      </ng-container>
      <ng-container *ngIf="loadingPdf">
        <div class="d-flex align-items-center" *ngIf="listadoCamionChoferSelectCount > 0">
          <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
          <strong>{{messageLoading}}</strong>
        </div>
      </ng-container>
    </div>

    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">
              <mdb-checkbox *ngIf="existePDFs()" 
                [(ngModel)]="checkAllRecorrido" 
                (change)="checkAllRecorridosChange($event)"
                [checked]="true">
              </mdb-checkbox>
            </th>
            <th scope="col">N° Rec.</th>
            <th scope="col">Patente</th>
            <th scope="col">Chofer</th>
            <th scope="col">N° Docs.</th>
            <th scope="col">Valor $</th>
            <th scope="col">Bultos</th>
            <th scope="col">Vol. C.</th>
            <th scope="col">Vol. A.</th>
            <th scope="col">Dif.</th>
            <th scope="col">Peso C.</th>
            <th scope="col">Peso A.</th>
            <th scope="col">Dif.</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody *ngIf="loadingCamion">
          <tr>
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr *ngFor="let cam of listadoCamionChofer; let i = index"
            [ngClass]="{estadoCamion1:cam.estado == 'En Carga', estadoCamion2: cam.estado == 'Despachado', estadoCamion3: cam.estado == 'Liquidado'}">
            <td>
              <mdb-checkbox *ngIf="cam.codigo_estado != 4 && cam.total_documentos > 0"
                [id]="'checkRecorrido' + i"
                [(ngModel)]="cam.seleccion" 
                (change)="checkRecorridoChange(i, $event)">
              </mdb-checkbox>
            </td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.correlativo }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.patente }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.nombre_chofer }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.total_documentos | numerico }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">$ {{ cam.total_facturas | numerico }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)"> {{cam.total_bultos}} </td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.volumen_maximo_camion | numerico }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.volumen_maximo_recorrido | numerico }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.diferencia_volumen | numerico }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.peso_maximo_camion | numerico }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.peso_maximo_recorrido | numerico }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.diferencia_peso | numerico }}</td>
            <td *ngIf="cam.codigo_estado != 4 && cam.total_documentos > 0">
              <button class="btn-actions-sm" [disabled]="cam.despachado" color="success" mdbBtn type="button"
                mdbWavesEffect (click)="despacharRecorrido(cam)" mdbTooltip="Despachar" placement="right">
                <mdb-icon fas icon="luggage-cart"></mdb-icon>
              </button>
              <button class="btn-actions-sm" color="dark" mdbBtn type="button" size="sm" mdbWavesEffect
                data-toggle="modal" data-target="#dvModalmostarRutas" (click)="showModalmostrarRutas(cam)"
                mdbTooltip="Mostrar Rutas" placement="right">
                <mdb-icon fas icon="map-marked-alt"></mdb-icon>
              </button>
              <button class="btn-actions-sm" color="info" mdbBtn type="button" size="sm" mdbWavesEffect
                data-toggle="modal" data-target="#dvModalVerDetalleCamion"
                (click)="showModalVerDetalleCamionChofer(cam)" mdbTooltip="Ver detalle" placement="right">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
              <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
                [disabled]="cam.despachado" (click)="eliminarRecorrido(cam)" mdbTooltip="Liberar" placement="right">
                <mdb-icon fas icon="ban"></mdb-icon>
              </button>

              <!-- SE DESACOPLA GENERACION PDF -->
              <!-- <ng-container *ngIf="!cam.loadingPdf">
                <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm"
                  (click)="showModalPdf_data(cam)" mdbTooltip="Generar PDFs" placement="right">
                  <mdb-icon fas icon="file-pdf"></mdb-icon>
                </button>
              </ng-container> -->
              <ng-container *ngIf="cam.loadingPdf">
                <mdb-spinner spinnerColor="blue" spinnerType="small"></mdb-spinner>
              </ng-container>

              <button class='btn btn-info btn-actions-sm' mdbBtn type="button" mdbWavesEffect
                (click)='showModalExcel_data(cam)' mdbTooltip='Generar Listado de Carga' placement='top'>
                <mdb-icon fas icon='file-excel'></mdb-icon>
              </button>
            </td>
            <td *ngIf="cam.codigo_estado == 1 && cam.total_documentos == 0">
              <!-- EDITAR CAMION -->
              <button class='btn btn-info btn-actions-sm' mdbBtn type="button" mdbWavesEffect
                (click)='EditarCamion(cam)'>
                <mdb-icon fas icon='edit'></mdb-icon>
              </button>

              <!-- ELIMINAR CAMION -->
              <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
                (click)="eliminarCamion(cam)">
                <mdb-icon fas icon="trash"></mdb-icon>
              </button>

            </td>
          </tr>
          <tr *ngIf="listadoCamionChofer.length==0">
            <td colspan="100%" style="text-align: center">No se encontraron resultados.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div id="info" class="MdbColorEstado">
      <div class="mb-2 wow">
        <div class="col">
          <div class="row">
            <div style="width: 10%;">
              <input disabled value="" type="text" class="mdFormInput form-control estadoCamion3" readonly />
              <label class="mdFormLabel"> Liquidado</label>
            </div>
            <div style="width: 10%;">
              <input disabled value="" type="text" class="mdFormInput form-control estadoCamion2" readonly />
              <label class="mdFormLabel"> Despachado</label>
            </div>
            <div style="width: 10%;">
              <input disabled value="" type="text" class="mdFormInput form-control estadoCamion1" readonly />
              <label class="mdFormLabel"> En Carga</label>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>



<!-- MODAL DETALLE DOCUMENTO -->
<div style="overflow-y: auto;" mdbModal #verDetalleCamionChofer="mdb-modal" class="modal fade"
  id="dvModalVerDetalleCamion" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <ng-container *ngIf="listadoDetalleDocumentos && recorridoDetalleSeleccionado">
    <div class="modal-dialog modal-fluid" style="width: 80%;" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Detalle Documento
            <div class="resultados">
              <strong>Recorrido</strong><span class="dummyTxt">{{recorridoDetalleSeleccionado.recorrido_codigo}}</span>
              <strong>Fecha</strong><span class="dummyTxt">{{recorridoDetalleSeleccionado.fecha | date}}</span>
              <strong>Despacho</strong><span class="dummyTxt">{{recorridoDetalleSeleccionado.fecha | date}}</span>
              <strong>Patente</strong><span class="dummyTxt">{{recorridoDetalleSeleccionado.patente}}</span>
              <strong>Chofer</strong><span class="dummyTxt">{{recorridoDetalleSeleccionado.nombre_chofer}}</span>
              <strong>Estado</strong><span class="dummyTxt">{{recorridoDetalleSeleccionado.estado}}</span>
            </div>
          </h4>

          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
            (click)="cerrarModalDetalleCamionChofer()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body" style="overflow-y: scroll;">


          <div class="table-responsive">
            <table class="table table-striped table-hover table-sm align-middle">
              <thead class="grey lighten-2">
                <tr>
                  <mdb-checkbox name="detalle-all" *ngIf="!recorridoDetalleSeleccionado.despachado"
                    [checked]="listadoDetalleCamionChofer.length === listadoDetalleDocumentos.length"
                    (change)="checkAll($event);">
                  </mdb-checkbox>
                  <th scope="col" style="max-width: 30px;">N° Doc.</th>
                  <th scope="col">Nombre Cliente</th>
                  <th scope="col">Vendedor</th>
                  <th scope="col">Direccion</th>
                  <th scope="col">Comuna</th>
                  <th scope="col">Cajas</th>
                  <th scope="col">Unidad</th>
                  <th scope="col">Monto Total</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="loadingDetalles">
                  <td colspan="100%" style="text-align: center">
                    <mdb-spinner spinnerColor="blue"></mdb-spinner>
                  </td>
                </tr>
                <tr *ngIf="!loadingDetalles && listadoDetalleCamionChofer?.length === 0">
                  <td colspan="100%" style="text-align: center">
                    No se encontró información
                  </td>
                </tr>
                <tr *ngFor="let detCam of listadoDetalleCamionChofer; let i = index" (click)="ClickedRow(i)"
                  [class.active]="i == PintarRow">
                  <mdb-checkbox name="detalle-{{detCam.numero_documento}}"
                    *ngIf="!recorridoDetalleSeleccionado.despachado" [checked]="isChecked(detCam.numero_documento)"
                    (change)="checkHandle($event,detCam);  marcarFilaDocDetalle(i);">
                  </mdb-checkbox>
                  <td>{{ detCam.numero_documento }}</td>
                  <td>{{ detCam.nombre_cliente }}</td>
                  <td>{{ detCam.vendedor_nombre }}</td>
                  <td>{{ detCam.direccion_completa }}</td>
                  <td>{{ detCam?.comuna_despacho }}</td>
                  <td>{{ detCam.cajas | numerico}}</td>
                  <td>{{ detCam.unidad | numerico}}</td>
                  <td>$ {{ detCam.total_documentos | numerico }}</td>
                  <td>
                    <!-- <button [isDisabled]="recorridoDetalleSeleccionado.despachado"
                            *ngIf="!recorridoDetalleSeleccionado.despachado"
                            class="btn-actions-xxs" color="{{recorridoDetalleSeleccionado.despachado? 'default': 'primary'}}" mdbBtn type="button" mdbWavesEffect
                            [disabled]="detCam.despachado" (click)="eliminarRecorridoDetalle(detCam)" mdbTooltip="Eliminar">
                      <mdb-icon  class="fa-sm" fas icon="ban"></mdb-icon>
                    </button> -->
                  </td>
                </tr>
              </tbody>
              <app-pagination [context]="paginationContextDetalles" (onPageChange)="onPageChangeDetalles($event)"
                *ngIf="listadoDetalleCamionChoferAll?.length > 0"></app-pagination>
            </table>

          </div>

          <div class="row">
            <div class="col">
              <div class="resultados mb-2">
                <strong>Docs.</strong><span class="dummyTxt">{{listadoDetalleCamionChofer?.length > 0 ? sumaDocumentos()
                  : 0}}</span>
                <strong>Cajas</strong><span class="dummyTxt">{{listadoDetalleCamionChofer?.length > 0 ? this.totalCajas :
                  0}}</span>
                <strong>Unidad</strong><span class="dummyTxt">{{listadoDetalleCamionChofer?.length > 0 ? this.totalUnidad :
                  0}}</span>
                <strong>Vol.</strong><span class="dummyTxt">{{(listadoDetalleCamionChofer?.length > 0 ? sumaVolumen() :
                  0) | numerico}}</span>
                <strong>Monto</strong><span class="dummyTxt">$ {{(listadoDetalleCamionChofer?.length > 0 ? sumaMonto() :
                  0) | numerico}}</span>
              </div>
            </div>
          </div>

          <div class="d-flex align-items-center" *ngIf="loadingPdfModal">
            <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
            <strong>{{messageLoading}}</strong>
          </div>

        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-sm btn-default waves-light" size="sm" data-dismiss="modal"
            (click)="CerrarDetalleDoc(); verDetalleCamionChofer.hide()" mdbWavesEffect>
            Cerrar
          </button>
          <ng-container *ngIf="listadoDetalleDocumentos.length >= 1">
            <button [isDisabled]="recorridoDetalleSeleccionado.despachado" mdbBtn type="button"
              class="btn btn-sm btn-primary  waves-light"
              color="{{recorridoDetalleSeleccionado.despachado? 'default': 'primary'}}" size="sm"
              (click)="!recorridoDetalleSeleccionado.despachado ? eliminarRecorridoDetalleList() : null" mdbWavesEffect>
              Liberar
            </button>
            <button [isDisabled]="recorridoDetalleSeleccionado.despachado" mdbBtn type="button"
              class="btn btn-sm btn-primary  waves-light"
              color="{{recorridoDetalleSeleccionado.despachado? 'default': 'primary'}}" size="sm"
              (click)="!recorridoDetalleSeleccionado.despachado ? ReAsignarRecorridoDetalleList() : null"
              mdbWavesEffect>
              Reasignar
            </button>
          </ng-container>

          <div class="right">
            <button mdbBtn type="button" size="sm" color="success" mdbWavesEffect class="btn btn-sm"
              (click)="downloadExcelPdf('XLS', recorridoDetalleSeleccionado)">
              Excel
            </button>
            <!-- (click)="showModalPdfDetalleDoc('PDF', recorridoDetalleSeleccionado)" -->
            <button class='btn btn-info' mdbBtn type="button" size="sm" mdbWavesEffect
              (click)="ObtenerDataToPdfModal(recorridoDetalleSeleccionado)" mdbTooltip='Generar PDFs'
              placement='top'
              [disabled]="loadingPdfModal">
              <mdb-icon fas icon='file-pdf'></mdb-icon>
              PDF
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

</div>
<!-- MODAL ASIGNAR CAMIONES -->
<ruteador-modal-asignar queryType="RUTEADOR_MANUAL" (onSuccess)="UpdateFiltros()"
  (onShowModalRutasRequest)="showModalverAddEditRutasModal()" [events]="eventsSubject.asObservable()" (onActualizarListaChoferes)="buscarPorFiltroDetalle()">
</ruteador-modal-asignar>

<!-- MODAL MOSTRAR RUTAS -->
<app-modal-rutas-camion></app-modal-rutas-camion>
<!-- <div mdbModal #mostrarRutas="mdb-modal" class="modal fade" id="dvModalMostrarRutas" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header" style="
      padding-bottom: 4px;
      padding-top: 0px;
  ">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Mostrar Rutas
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="mostrarRutas.hide()" style="

    margin-top: 0px;
    height: 41px;
    padding-top: 5‒;
    padding-top: 5px;">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body" style="overflow-y:auto;height: 480px;">
        <div class="card-body justify-content-between">
          <div class="row filtros-body">
            <div class="col" style="max-width:100%;">
              <agm-map id="mapRutas" (mapReady)="onMapReadyShowRutas($event)">
              </agm-map>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer justify-content-between" style="
      padding-top: 0px;
      padding-bottom: 0px;
      padding-left: 0px;
      padding-right: 0px;
      height: 71px;
      ">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="mostrarRutas.hide()"
          mdbWavesEffect>
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div> -->

<!-- MODAL ADD/EDIT RUTA -->
<app-modal-add-edit-ruta (onSuccess)="buscarPorFiltroDetalle()" 
  (onShowModalRutasRequest)="showModalverAddEditRutasModal()">
</app-modal-add-edit-ruta>


<app-modal-confirm title="{{ tittle }}" contentText="{{message}}">
</app-modal-confirm>
